<template>
  <div>
    <page-header
      :breadcrumRoutes="routes"
      title="Formulario alta de cargas individual"
    />

    <a-form
      name="form"
      layout="vertical"
      ref="formRef"
      :model="formData"
      :rules="formRules"
    >
      <a-row type="flex" class="mb-2" :gutter="[20, 8]">
        <a-col flex="auto">
          <a-card>
            <a-row type="flex">
              <a-col :span="24">
                <a-form-item
                  label="Envío de información a"
                  required
                  name="typeform"
                >
                  <a-radio-group
                    name="radioGroup"
                    v-model:value="formData.typeform"
                  >
                    <a-radio value="1">Colaborador</a-radio>
                    <a-radio value="2">Compañía</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
        <a-col flex="auto">
          <a-card>
            <a-row type="flex">
              <a-col :span="24">
                <a-form-item
                  label="Inicio de vigencia"
                  required
                  name="validityDate"
                >
                  <a-date-picker
                    placeholder="DD-MM-AAAA"
                    v-model:value="formData.validityDate"
                    :format="formatDate"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
      </a-row>

      <a-card>
        <a-row>
          <a-col>
            <a-typography-title class="text-gray-8" :level="4">
              Datos titular
            </a-typography-title>
          </a-col>
        </a-row>
        <a-row :gutter="16" type="flex">
          <a-col :xs="24" :md="8">
            <a-form-item ref="rut" label="RUT" name="rut" has-feedback>
              <input-rut v-model="formData.rut" :loading="loadingCompanies" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>

      <a-card class="mt-2">
        <a-row>
          <a-col>
            <a-typography-title class="text-gray-8" :level="4">
              Datos corporativos
            </a-typography-title>
          </a-col>
        </a-row>
        <a-row :gutter="[16, 4]" type="flex">
          <a-col :xs="24" :md="12">
            <a-form-item
              ref="company"
              label="Empresa"
              name="company"
              has-feedback
            >
              <select-ordered
                placeholder="Selecciona una empresa"
                :disabled="inputsLockState[0].disabled"
                v-model="formData.company"
                :options="companies"
              ></select-ordered>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="12">
            <a-form-item
              ref="insurance"
              label="Aseguradora"
              name="insurance"
              has-feedback
            >
              <select-ordered
                placeholder="Selecciona una aseguradora"
                :disabled="inputsLockState[0].disabled"
                :loading="inputsLockState[1].loading"
                v-model="formData.insurance"
                :options="insuranceCompanies"
              ></select-ordered>
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>

      <a-card class="mt-2">
        <a-typography-title class="text-gray-8" :level="4">
          Pólizas y coberturas
        </a-typography-title>
        <div style="display: flex; flex-direction: column; gap: 16px">
          <a-row
            :gutter="16"
            v-if="
              validRut &&
              formData.rut !== '' &&
              employeeId !== '' &&
              formData.company !== '' &&
              formData.insurance !== ''
            "
          >
            <a-col :xs="24" :md="8">
              <a-button
                class="button_with_icon"
                @click="openPolicyCoverage"
                id="coverages_and_policies"
              >
                Pólizas y coberturas
                <a-tag
                  color="geekblue"
                  v-if="currentCoverages.length > 0"
                  class="ml-2 mr-0"
                >
                  {{ currentCoverages.length }}
                </a-tag>
              </a-button>
              <policy-coverages
                ref="policyCoveragesModalRef"
                v-model="policyStatus"
                :loading="loadingPolicyCoverages"
                :currentCoverages="currentCoverages"
                :notCurrentCoverages="notCurrentCoverages"
              />
            </a-col>
          </a-row>
          <a-row :gutter="16" align="middle">
            <a-col :xs="24" :md="8">
              <a-form-item
                ref="currentPolicy"
                label="Pólizas"
                name="currentPolicy"
                has-feedback
              >
                <select-ordered
                  :disabled="inputsLockState[2].disabled"
                  :loading="inputsLockState[2].loading"
                  v-model="formData.currentPolicy"
                  :options="companyPolicies"
                  mode="multiple"
                  @change="handleAddPolicy"
                  allowClear
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row
            v-for="(policy, index) in formData.policies"
            :key="index"
            align="middle"
            :gutter="16"
          >
            <a-col :xs="24" :md="8">
              <a-form-item
                :name="['policies', index, 'groupCompanies']"
                :label="`Grupos de póliza ${policy.numberPolicy}`"
                style="display: flex"
              >
                <select-ordered
                  v-model="policy.groupCompanies"
                  :options="policy.groupOptions"
                  mode="multiple"
                  allowClear
                />
              </a-form-item>
            </a-col>
            <a-col>
              <a-button danger @click="handleDeletePolicy(policy.policyId)">
                <template #icon><DeleteOutlined /></template>
              </a-button>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <template
                v-if="formData.typeform == 1 && formData.policies.length > 0"
              >
                <a-form-item
                  name="documents"
                  :label="`Seleccionar formularios de ${
                    insuranceCompanies.find(
                      (x) => x.value == formData.insurance
                    )?.label || ''
                  }`"
                >
                  <!-- Documentos -->
                  <a-checkbox-group v-model:value="formData.documents">
                    <div v-for="d in insuranceDocuments" :key="d.value">
                      <a-checkbox :value="d.value">
                        {{ d.label }}
                      </a-checkbox>
                    </div>
                  </a-checkbox-group>
                </a-form-item>
              </template>
              <template
                v-if="
                  formData.typeform == 2 &&
                  formData.insurance !== null &&
                  formData.insurance !== ''
                "
              >
                <a-row :gutter="[24, 8]" type="flex">
                  <a-col>
                    <!-- Subida de archivo -->
                    <a-form-item
                      name="fileList"
                      :label="`Adjuntar archivos de incorporación de cargas de ${
                        insuranceCompanies.find(
                          (x) => x.value == formData.insurance
                        )?.label || ''
                      }`"
                      has-feedback
                    >
                      <a-upload
                        :file-list="formData.fileList"
                        :multiple="true"
                        :remove="handleRemove"
                        :before-upload="beforeUpload"
                        accept=".pdf,.jpeg,.png,.jpg"
                      >
                        <a-button>
                          <upload-outlined></upload-outlined>
                          Subir archivo
                        </a-button>
                      </a-upload>
                    </a-form-item>
                  </a-col>
                </a-row>
              </template>
            </a-col>
          </a-row>
        </div>
      </a-card>

      <a-card v-if="formData.typeform == 2" class="mt-2">
        <a-typography-title class="text-gray-8" :level="4">
          Cargas
        </a-typography-title>
        <div>
          <a-empty
            v-if="formData.dependents.length === 0"
            description="No has agregado cargas"
          />
          <template
            v-for="(dependent, dependentIndex) in formData.dependents"
            :key="dependentIndex"
          >
            <a-row type="flex" justify="space-between" align="middle">
              <a-col>
                <a-typography-title :level="5" style="margin: 0">
                  Carga {{ dependentIndex + 1 }}
                </a-typography-title>
              </a-col>
              <a-col>
                <a-button
                  danger
                  size="small"
                  @click="() => handleDeleteDependent(dependentIndex)"
                >
                  Eliminar
                </a-button>
              </a-col>
            </a-row>
            <a-row type="flex" :gutter="16" style="margin-top: 16px">
              <a-col :span="12">
                <a-form-item
                  :name="['dependents', dependentIndex, 'rut']"
                  label="Rut"
                  :rules="[
                    { validator: rutValidator },
                    { required: true, message: 'El rut es obligatorio.' }
                  ]"
                >
                  <input-rut v-model="dependent.rut" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                  :name="['dependents', dependentIndex, 'dateOfBirth']"
                  label="Fecha de nacimiento"
                  :rules="{
                    required: true,
                    message: 'La fecha de nacimiento es obligatoria.',
                    trigger: 'change',
                    type: 'object'
                  }"
                >
                  <a-date-picker
                    :style="{ width: '100%' }"
                    format="DD-MM-YYYY"
                    placeholder="Fecha de nacimiento"
                    v-model:value="dependent.dateOfBirth"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row type="flex" :gutter="16">
              <a-col :span="12">
                <a-form-item
                  :name="['dependents', dependentIndex, 'firstName']"
                  label="Primer nombre"
                  :rules="{
                    required: true,
                    message: 'El primer nombre es obligatorio.'
                  }"
                >
                  <input-text
                    v-model="dependent.firstName"
                    placeholder="Primer nombre"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                  :name="['dependents', dependentIndex, 'secondName']"
                  label="Segundo nombre"
                >
                  <input-text
                    v-model="dependent.secondName"
                    placeholder="Segundo nombre"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row type="flex" :gutter="16">
              <a-col :span="12">
                <a-form-item
                  :name="['dependents', dependentIndex, 'firstSurname']"
                  label="Apellido paterno"
                  :rules="{
                    required: true,
                    message: 'El primer apellido es obligatorio.'
                  }"
                >
                  <input-text
                    v-model="dependent.firstSurname"
                    placeholder="Apellido paterno"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                  :name="['dependents', dependentIndex, 'secondSurname']"
                  label="Apellido materno"
                >
                  <input-text
                    v-model="dependent.secondSurname"
                    placeholder="Apellido materno"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                  :name="['dependents', dependentIndex, 'relationship']"
                  label="Relación"
                  :rules="{
                    required: true,
                    message: 'La relación es obligatoria.'
                  }"
                >
                  <select-ordered
                    v-model="dependent.relationship"
                    :options="relationOptions"
                    placeholder="Ingrese relación"
                  />
                </a-form-item>
              </a-col>
              <a-col
                v-if="selectedFormFields.some((f) => f.field === 'gender')"
                :span="12"
              >
                <a-form-item
                  :name="['dependents', dependentIndex, 'gender']"
                  label="Sexo designado al nacer"
                  :rules="{
                    required: !!selectedFormFields.find((f) => f.field === 'gender')?.required,
                    message: 'El sexo designado al nacer es obligatorio.'
                  }"
                >
                  <select-ordered
                    v-model="dependent.gender"
                    :options="genderOptions"
                    placeholder="Seleccione una opción"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </div>
        <a-row type="flex" justify="start">
          <a-button @click="handleAddDependent">Agregar carga</a-button>
        </a-row>
      </a-card>

      <Transition>
        <!-- <a-card class="mt-2" v-if="formData.typeform == 1"> -->
        <a-card class="mt-2">
          <a-row :gutter="32">
            <a-col :xs="24" :md="12" v-if="formData.typeform == 1">
              <a-typography-title class="text-gray-8" :level="4">
                Mensaje a colaborador
              </a-typography-title>
              <a-form-item
                ref="message"
                label="Escribe mensaje para colaborador"
                name="message"
                has-feedback
              >
                <a-textarea
                  v-model:value="formData.message"
                  placeholder="Escribe aquí..."
                  :rows="8"
                  :maxlength="3000"
                />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :md="12" v-if="formData.typeform == 2">
              <a-typography-title class="text-gray-8" :level="4">
                Mensaje a la companía
              </a-typography-title>
              <a-form-item
                ref="message"
                label="Escribe mensaje para la compañía aseguradora"
                name="message"
                has-feedback
              >
                <a-textarea
                  v-model:value="formData.message"
                  placeholder="Escribe aquí..."
                  :rows="8"
                  :maxlength="3000"
                />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :md="12">
              <a-row :gutter="[24, 8]" type="flex">
                <a-col :span="24">
                  <a-form-item name="optionalFiles" label="Archivos opcionales">
                    <a-upload
                      :file-list="formData.optionalFiles"
                      :multiple="true"
                      :remove="handleRemoveOptional"
                      :before-upload="beforeUploadOptional"
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                    >
                      <a-button>
                        <upload-outlined></upload-outlined>
                        Subir Archivo
                      </a-button>
                    </a-upload>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-card>
      </Transition>

      <a-form-item class="mt-2">
        <a-row type="flex" class="justify-content-end">
          <a-col>
            <a-button
              size="large"
              class="px-4"
              type="primary"
              @click="onSubmitForm"
              block
            >
              Siguiente
            </a-button>
          </a-col>
        </a-row>
      </a-form-item>
    </a-form>

    <!-- Modal mostrando informacion de lo que escribio el usuario -->
    <a-modal
      :wrapClassName="'modal-xs'"
      v-model:visible="resumeModal.visibility"
      title="Resumen de alta de cargas individual"
      @cancel="closeResumeModal"
      :closable="!resumeModal.buttonLoading"
      :maskClosable="false"
    >
      <template #footer>
        <a-row type="flex" justify="end">
          <a-col>
            <a-space>
              <a-button
                @click="closeResumeModal"
                :disabled="resumeModal.buttonLoading"
              >
                Cancelar
              </a-button>
              <a-button
                key="submit"
                type="primary"
                @click="createAlta"
                :loading="resumeModal.buttonLoading"
              >
                Enviar
              </a-button>
            </a-space>
          </a-col>
        </a-row>
      </template>

      <a-typography-title class="text-gray-8 fw-regular mb-4" :level="5">
        Revisa que los datos ingresados estén correctos.
      </a-typography-title>
      <a-descriptions class="mb-4" bordered>
        <a-descriptions-item label="Inicio de vigencia" :span="3">
          {{ resumeModal.data.date }}
        </a-descriptions-item>
      </a-descriptions>
      <a-descriptions class="mb-4" title="Datos corporativos" bordered>
        <a-descriptions-item label="Aseguradora" :span="3">
          {{ resumeModal.data.insurer }}
        </a-descriptions-item>
        <a-descriptions-item label="Empresa" :span="3">
          {{ resumeModal.data.company }}
        </a-descriptions-item>
        <a-descriptions-item label="Pólizas" :span="3">
          {{ resumeModal.data.policies }}
        </a-descriptions-item>
        <a-descriptions-item
          label="Formularios"
          :span="3"
          v-if="formData.typeform == 1 && resumeModal.data.documents.length > 0"
        >
          <ul style="margin: 0; padding: 0 0 0 8px">
            <li
              v-for="(d, index_d) in resumeModal.data.documents"
              :key="index_d"
            >
              {{ d }}
            </li>
          </ul>
        </a-descriptions-item>
        <a-descriptions-item
          label="Formularios"
          :span="3"
          v-else-if="resumeModal.data.files.length > 0"
        >
          <ul style="margin: 0; padding: 0 0 0 8px">
            <li v-for="(d, index_f) in resumeModal.data.files" :key="index_f">
              {{ d }}
            </li>
          </ul>
        </a-descriptions-item>
      </a-descriptions>
      <a-descriptions title="Datos colaborador" class="mb-4" bordered>
        <a-descriptions-item label="RUT" :span="3">
          {{ resumeModal.data.rut }}
        </a-descriptions-item>
        <a-descriptions-item label="Nombre" :span="3">
          {{ employeeName || '' }}
        </a-descriptions-item>
      </a-descriptions>
      <a-descriptions
        :title="`Carga ${dependentIndex + 1}`"
        class="mb-4"
        v-for="(dependent, dependentIndex) in resumeModal.data.dependents"
        :key="dependent.rut"
        bordered
      >
        <a-descriptions-item label="RUT" :span="3">
          {{ dependent.rut }}
        </a-descriptions-item>
        <a-descriptions-item label="Nombre" :span="3">
          {{ dependent.firstName }} {{ dependent.firstSurname }}
        </a-descriptions-item>
      </a-descriptions>
    </a-modal>

    <!-- Modal sucess -->
    <template v-if="show_sucess">
      <a-modal
        :wrapClassName="'modal-xs'"
        v-model:visible="show_sucess"
        centered
        footer=""
        :maskClosable="false"
      >
        <a-result
          centered
          status="success"
          title="Ticket creado"
          sub-title="Tu ticket de alta de cargas individual ha sido creado con éxito."
        >
          <template #extra>
            <router-link
              class="justify-content-center d-flex"
              :to="{ name: 'AltaCargasDetalle', params: { id: ticketId } }"
            >
              <a-button key="console" type="primary">Ver ticket</a-button>
            </router-link>
          </template>
        </a-result>
      </a-modal>
    </template>
    <template v-if="showError">
      <a-modal
        :wrapClassName="'modal-xs'"
        v-model:visible="showError"
        centered
        footer=""
        :maskClosable="false"
      >
        <a-result
          centered
          status="error"
          title="Error"
          sub-title="No se ha podido generar el ticket. Asegúrate de que exista un Ticket de Alta generado previamente."
        >
          <template #extra>
            <a-button type="primary" @click="() => handleOk()">Cerrar</a-button>
          </template>
        </a-result>
      </a-modal>
    </template>
    <pending-policy-modal
      :visible="showPendingPolicyModal"
      :conflicts="pendingPolicyConflicts"
      ticket-type-label="alta de cargas"
      :employee-rut="formData.rut"
      ticket-route-name="AltaCargasDetalle"
      @update:visible="showPendingPolicyModal = $event"
    />
  </div>
</template>

<script>
import { computed, reactive, ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import { UploadOutlined } from '@ant-design/icons-vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import moment from 'moment';
import {
  FETCH_INSURANCE_COMPANIES,
  FETCH_INSURANCE_COMPANIES_DOCUMENTS,
  FETCH_EMPLOYEE_DATA_BY_RUT,
  FETCH_CURRENT_EMPLOYEE_COVERAGE,
  GET_INSURANCE_COMPANIES,
  GET_LOGGED_USER,
  GET_INSURANCE_COMPANIES_DOCUMENTS,
  GET_EMPLOYEE_DATA,
  POST_EMPLOYEE_DEPENDENTS_INCORPORATION,
  POST_INSURANCE_DEPENDENTS_INCORPORATION,
  ACTION_CURRENT_EMPLOYEE_COVERAGE,
  FETCH_COMPANIES_FOR_DEPENDENTS_INCORPORATION_FORM,
  FETCH_POLICIES_FOR_DEPENDENTS_INCORPORATION_FORM,
  FETCH_TICKET_DEPENDANTS_INCORPORATIONS
} from '@/store/types';
import parseDate from '@/utils/dateFormatter';
import PageHeader from '@/components/page-header.vue';
import rutHelper from '@/utils/Ruts';
import { genderOptions } from '@/utils/gender';
import notification from '@/utils/notifications';
import Rut from '@/utils/Ruts';
import EmployeePolicyAndCoverages from '@/components/incorporations/employee-policy-and-coverages.vue';
import { DeleteOutlined } from '@ant-design/icons-vue';
import InputText from '@/bewell-components/form-controls/input-text.vue';
import InputRut from '@/bewell-components/form-controls/input-rut.vue';
import SelectOrdered from '@/bewell-components/form-controls/select-ordered.vue';
import { FETCH_TABLE_TICKETS_TEST } from '@/store/ticket/datatable/types';
import PendingPolicyModal from '@/components/tickets/PendingPolicyModal.vue';

const routes = [
  {
    path: '/altas-cargas',
    breadcrumbName: 'Altas cargas'
  },
  {
    breadcrumbName: 'Formulario individual'
  }
];

export default {
  name: 'AltaCargasIndividual',
  components: {
    'upload-outlined': UploadOutlined,
    'page-header': PageHeader,
    'policy-coverages': EmployeePolicyAndCoverages,
    'input-text': InputText,
    'input-rut': InputRut,
    'select-ordered': SelectOrdered,
    DeleteOutlined,
    PendingPolicyModal
  },
  setup() {
    const router = useRouter();
    // * Form
    // Reference to the form
    const formRef = ref();
    const policyStatus = ref('vigente');

    // Final id once the ticket is created
    const ticketId = ref('');

    // Date format
    const formatDate = 'DD-MM-YYYY';

    const handleAddDependent = () => {
      formData.dependents.push({
        rut: '',
        firstName: '',
        secondName: '',
        firstSurname: '',
        secondSurname: '',
        dateOfBirth: null,
        gender: null
      });
    };

    const handleDeleteDependent = (dependentIndex) => {
      formData.dependents = formData.dependents.filter(
        (_, idx) => idx !== dependentIndex
      );
    };

    const handleDeleteAllDependents = () => {
      formData.dependents.splice(0, formData.dependents.length);
    };

    const rutValidator = (_, value) => {
      const isValid = rutHelper.validateRut(value);
      if (value && !isValid) return Promise.reject('RUT inválido.');

      if (formData.rut === value)
        return Promise.reject('Debe ser un RUT distinto al RUT del titular.');

      if (formData.dependents.filter((d) => d.rut === value).length > 1)
        return Promise.reject('RUT repetido.');

      return Promise.resolve();
    };

    // Data saved from the form
    const formData = reactive({
      typeform: '1',
      validityDate: '',
      rut: '',
      company: '',
      insurance: '',
      message: '',
      policies: [],
      currentPolicy: [],
      documents: [],
      fileList: [],
      optionalFiles: [],
      dependents: []
    });

    const updateMessage = () => {
      switch (formData.typeform) {
        case '1':
          formData.message =
            'Para que tus cargas puedan recibir los beneficios de tu empresa es necesario que completes los siguientes pasos:';
          break;
        case '2':
          formData.message =
            'A través del presente correo solicitamos la siguiente alta de cargas:';
          break;
        default:
          formData.message =
            'Por favor selecciona un tipo de formulario válido.';
      }
    };

    updateMessage();

    watch(
      () => formData.typeform,
      () => {
        updateMessage();
      }
    );
    const formatRuts = () => {
      formData.rut = rutHelper.formatRut(formData.rut);
    };
    const showSucess = ref(false);
    const options1 = ref([
      {
        value: 'lucy',
        label: 'Lucy'
      }
    ]);

    const handleAddPolicy = () => {
      formData.currentPolicy.forEach((policyId) => {
        const policy = companyPolicies.value.find((p) => p.value == policyId);
        const foundPolicy = formData.policies.find(
          (p) => p.policyId == policyId
        );
        if (!foundPolicy) {
          const newPolicy = {
            numberPolicy: policy.label,
            policyId,
            groupCompanies: [],
            groupOptions: policy.groupOptions
          };
          formData.policies = [...formData.policies, newPolicy];
        }
      });
      formData.policies = formData.policies.filter((p) =>
        formData.currentPolicy.includes(p.policyId)
      );
    };

    const handleDeletePolicy = (policyId) => {
      formData.policies = formData.policies.filter(
        (p) => p.policyId !== policyId
      );
      formData.currentPolicy = formData.currentPolicy.filter(
        (p) => p !== policyId
      );
    };

    const employeeId = ref('');
    const employeeName = ref('');

    const inputsLockState = reactive([
      {
        id: 1,
        disabled: false,
        loading: false,
        name: 'company'
      },
      {
        id: 2,
        disabled: true,
        loading: false,
        name: 'insurance'
      },
      {
        id: 3,
        disabled: true,
        loading: false,
        name: 'policy'
      }
    ]);

    const inputStatesHeriarchy = (id) => {
      /* function to enable/disable inputs based on the hierarchy */
      const index = inputsLockState.findIndex((obj) => obj.id === id);
      let last_id;

      if (index >= 0) {
        inputsLockState[index].disabled = false;

        if (inputsLockState[index + 1] != undefined) {
          inputsLockState[index + 1].disabled = false;
          last_id = inputsLockState[index + 1].id;
        }
      }

      for (let index = last_id; index < inputsLockState.length; index++) {
        inputsLockState[index].disabled = true;
      }
    };

    // RUT format validator
    const checkRut = async (_, value) => {
      if (!value) {
        return Promise.reject('Ingrese RUT');
      }
      if (!rutHelper.validateRut(value)) {
        return Promise.reject('RUT no válido');
      }
      if (!employeeId.value && !loadingCompanies.value) {
        return Promise.reject('No se encontró al titular');
      }
      return Promise.resolve();
    };

    // Form rules
    const formRules = {
      validityDate: [
        {
          required: true,
          message: 'Seleccione una fecha',
          trigger: 'change',
          type: 'object'
        }
      ],
      rut: [
        {
          required: true,
          validator: checkRut,
          trigger: 'change'
        }
      ],
      company: [
        {
          required: true,
          message: 'Seleccione una empresa',
          trigger: 'change',
          type: 'string'
        }
      ],
      insurance: [
        {
          required: true,
          message: 'Seleccione una aseguradora',
          trigger: 'change',
          type: 'string'
        }
      ],
      message: [
        {
          required: true,
          message: 'Escriba un mensaje',
          trigger: 'change',
          type: 'string'
        }
      ],
      policies: [
        {
          type: 'array',
          required: true,
          message: 'Seleccione una póliza',
          trigger: 'change'
        }
      ],
      documents: [
        {
          type: 'array',
          required: true,
          message: 'Seleccione un documento',
          trigger: 'change'
        }
      ],
      fileList: [
        {
          type: 'array',
          required: true,
          message: 'Agregue un documento',
          trigger: 'change'
        }
      ]
    };

    // When 'Envío de información a' changes, clear whichever value doesn't apply anymore
    watch(
      () => formData.typeform,
      (newVal) => {
        // If Colaborador is selected, clear the uploaded files
        if (newVal === '1') {
          formData.fileList = [];
        } else {
          // Otherwise clear the checkbox-selectable documents
          formData.documents = [];
        }
      }
    );

    const showPendingPolicyModal = ref(false);
    const pendingPolicyConflicts = ref([]);

    const getLastTicketState = (ticket) => {
      if (ticket?.states?.length) {
        return [...ticket.states]
          .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
          .at(-1);
      }
      if (ticket?.state) {
        return ticket.state;
      }
      return ticket?.state ?? null;
    };

    const isTicketPending = (ticket) => {
      if (ticket?.isRequesting === true || ticket?.state === 'requested') {
        return true;
      }
      const lastState = getLastTicketState(ticket);
      const stateId =
        lastState?.stateId ?? lastState?.id ?? lastState?.state?.id;
      if (stateId === undefined || stateId === null) {
        return false;
      }
      return stateId !== 3 && stateId !== 4;
    };

    const normalizePolicyValue = (value) => {
      if (value === null || value === undefined) return '';
      return String(value).trim().toLowerCase();
    };

    const extractTicketPolicies = (ticket) => {
      const policies =
        ticket?.policies ??
        ticket?.ticket?.policies ??
        ticket?.data?.policies ??
        [];
      const extracted = [];
      if (Array.isArray(policies)) {
        extracted.push(
          ...policies
            .map((p) => p?.id ?? p?.policyId ?? p?.numberPolicy ?? p)
            .map(normalizePolicyValue)
            .filter(Boolean)
        );
      } else {
        const single = normalizePolicyValue(policies);
        if (single) extracted.push(single);
      }
      // fallback: coverageGroupCompanies -> policy
      const coverages =
        ticket?.coverageGroupCompanies ??
        ticket?.ticket?.coverageGroupCompanies ??
        ticket?.data?.coverageGroupCompanies ??
        [];
      if (Array.isArray(coverages)) {
        coverages.forEach((c) => {
          const policy = c?.policy;
          const policyId = normalizePolicyValue(policy?.id);
          const policyNumber = normalizePolicyValue(policy?.numberPolicy);
          if (policyId) extracted.push(policyId);
          if (policyNumber) extracted.push(policyNumber);
        });
      }
      return extracted.filter(Boolean);
    };

    const TICKET_TYPE = 'Altas de cargas';

    const checkPendingPolicies = async () => {
      if (formData.typeform !== '2') {
        pendingPolicyConflicts.value = [];
        return false;
      }
      const normalizedRut = rutHelper.normalizeRut(formData.rut);
      if (!normalizedRut) {
        pendingPolicyConflicts.value = [];
        return false;
      }

      const resp = await store.dispatch(
        FETCH_TABLE_TICKETS_TEST,
        `type=${encodeURIComponent(
          TICKET_TYPE
        )}&employeeRut=${normalizedRut}&page=1&items_per_page=50`
      );
      const rows = resp?.data?.rows || [];
      const pendingRows = rows.filter(isTicketPending);

      const policyLabelByKey = new Map();
      const selectedPolicyKeys = [];

      const policiesFromForm = Array.isArray(formData.policies)
        ? formData.policies
        : [];
      if (policiesFromForm.length > 0) {
        policiesFromForm.forEach((p) => {
          const normalizedId = normalizePolicyValue(p.policyId);
          const normalizedLabel = normalizePolicyValue(p.numberPolicy);
          if (normalizedId) policyLabelByKey.set(normalizedId, p.numberPolicy);
          if (normalizedLabel)
            policyLabelByKey.set(normalizedLabel, p.numberPolicy);
          selectedPolicyKeys.push(
            ...[normalizedId, normalizedLabel].filter(Boolean)
          );
        });
      } else if (Array.isArray(formData.currentPolicy)) {
        formData.currentPolicy.forEach((policyId) => {
          const policy = companyPolicies.value?.find(
            (p) => p.value == policyId
          );
          const normalizedId = normalizePolicyValue(policyId);
          const normalizedLabel = normalizePolicyValue(policy?.label);
          if (normalizedId) policyLabelByKey.set(normalizedId, policy?.label);
          if (normalizedLabel)
            policyLabelByKey.set(normalizedLabel, policy?.label);
          selectedPolicyKeys.push(
            ...[normalizedId, normalizedLabel].filter(Boolean)
          );
        });
      }

      if (selectedPolicyKeys.length === 0) {
        pendingPolicyConflicts.value = [];
        return false;
      }

      const selectedDependents = formData.dependents.filter(
        (d) => d?.rut && rutHelper.normalizeRut(d.rut)
      );
      const selectedDependentRuts = new Set(
        selectedDependents
          .map((d) => rutHelper.normalizeRut(d.rut))
          .filter(Boolean)
      );

      if (selectedDependentRuts.size === 0) {
        pendingPolicyConflicts.value = [];
        return false;
      }

      const conflicts = [];

      const pendingChecks = pendingRows.map(async (row) => {
        const rowPolicies = extractTicketPolicies(row);
        const matchedPolicies = selectedPolicyKeys.filter((policyKey) =>
          rowPolicies.includes(policyKey)
        );
        if (matchedPolicies.length === 0) return;

        const dependentsResp = await store.dispatch(
          FETCH_TICKET_DEPENDANTS_INCORPORATIONS,
          row.id
        );
        const matchedLabels = matchedPolicies
          .map((key) => policyLabelByKey.get(key) || key)
          .filter(Boolean);

        const ticketDependents = Array.isArray(dependentsResp)
          ? dependentsResp
          : [];

        if (ticketDependents.length === 0) {
          return;
        }

        ticketDependents.forEach((dependent) => {
          const dependentRut = rutHelper.normalizeRut(
            dependent?.rut ??
              dependent?.dependent?.rut ??
              dependent?.employeeDependent?.dependent?.rut
          );
          if (!dependentRut || !selectedDependentRuts.has(dependentRut)) return;
          conflicts.push({
            id: `${row.id}-${dependentRut}`,
            policy: matchedLabels.join(', ') || '',
            ticketId: row.id,
            dependentRut
          });
        });
      });

      await Promise.all(pendingChecks);

      if (conflicts.length > 0) {
        pendingPolicyConflicts.value = conflicts;
        showPendingPolicyModal.value = true;
        return true;
      }

      pendingPolicyConflicts.value = [];
      return false;
    };

    // Presionar el boton de siguiente
    const onSubmitForm = async () => {
      try {
        if (formData.typeform == 2 && formData.dependents.length === 0) {
          notification('error', 'Error', 'Debes agregar al menos una carga.');
          return;
        }
        const hasPendingPolicy = await checkPendingPolicies();
        if (hasPendingPolicy) return;
        const resp = await formRef.value.validate();
        openResumeModal(resp);
      } catch (error) {
        console.log('error', error);
        formRef.value.scrollToField(error.errorFields[0].name[0]);
        notification('error', 'Error', 'Hay errores en el formulario.');
      }
    };

    // Crear ticket de alta a compañia
    const createAlta = async () => {
      resumeModal.buttonLoading = true;

      try {
        const body = new FormData();
        body.append('companyId', formData.company);
        body.append('brokerId', store.getters[GET_LOGGED_USER].id);
        body.append('insuranceCompanyId', formData.insurance);
        body.append('startDate', moment(formData.validityDate).format());
        body.append('rut', rutHelper.normalizeRut(formData.rut));
        formData.documents.forEach((e, i) => {
          body.append(`filesInsurance[${i}]`, e);
        });
        formData.policies.forEach((e, i) => {
          body.append(
            `policies[${i}]`,
            JSON.stringify({
              policyId: e.policyId,
              groupCompanies: e.groupCompanies
            })
          );
        });

        if (formData.typeform == 2) {
          body.append('message', formData.message);
          formData.fileList.forEach((file) => {
            body.append('file', file);
          });
          formData.optionalFiles.forEach((optFile) => {
            body.append('optionalFile', optFile);
          });
          formData.dependents.forEach((d, i) => {
            const dateOfBirth = moment(d.dateOfBirth);
            body.append(
              `dependents[${i}]`,
              JSON.stringify({
                ...d,
                rut: rutHelper.normalizeRut(d.rut),
                dateOfBirth
              })
            );
          });

          const resp = await store.dispatch(
            POST_INSURANCE_DEPENDENTS_INCORPORATION,
            body
          );
          ticketId.value = resp.id;
          show_sucess.value = true;
        } else {
          body.append('message', formData.message);
          formData.optionalFiles.forEach((e) => {
            body.append('file', e);
          });

          const resp = await store.dispatch(
            POST_EMPLOYEE_DEPENDENTS_INCORPORATION,
            body
          );
          ticketId.value = resp.id;
          showSucess.value = true;
          show_sucess.value = true;
        }
        formRef.value.resetFields();
        handleDeleteAllDependents();
      } catch (error) {
        console.error('error', error);
        showSucess.value = false;
        const errMsg = error?.response?.data?.message || 'Ha ocurrido un error';
        notification('error', 'Error', errMsg);
      }

      resumeModal.buttonLoading = false;
      closeResumeModal();
    };

    // * Subida de archivos
    const fileList = ref([]);
    const uploading = ref(false);

    // Eliminar un archivo de la lista de archivos
    const handleRemove = (file) => {
      const index = formData.fileList.indexOf(file);
      const newFileList = formData.fileList.slice();
      newFileList.splice(index, 1);
      formData.fileList = newFileList;
    };

    // Eliminar un archivo para la subida de archivos opcionales
    const handleRemoveOptional = (file) => {
      const index = formData.optionalFiles.indexOf(file);
      const newFileList = formData.optionalFiles.slice();
      newFileList.splice(index, 1);
      formData.optionalFiles = newFileList;
    };

    // Agregar un archivo opcional al input
    const beforeUploadOptional = (file) => {
      if (formData.optionalFiles.length < 5) {
        const fileSize = file.size / 1024 / 1024;
        if (fileSize > 5) {
          message.error('El archivo excede el peso máximo 5MB');
        } else {
          formData.optionalFiles = [...formData.optionalFiles, file];
        }
      } else {
        message.error('Máximo archivos a subir es 5');
      }
      return false;
    };

    // Metodo que se llama para subir al archivo, sirve para validar el peso del archivo
    const beforeUpload = (file) => {
      const fileSize = file.size / 1024 / 1024;
      if (fileSize > 5) {
        message.error('El archivo excede el peso máximo 5MB');
      } else {
        formData.fileList = [...formData.fileList, file];
      }
      return false;
    };

    // Subida de archivos al backend
    const handleUpload = async (id) => {
      const formData = new FormData();
      fileList.value.forEach((file) => {
        formData.append('file', file);
      });
      formData.append('ticketId', id);
    };

    // * Obtencion de data principal
    // Vuex
    const store = useStore();

    const companies = ref([]);
    const loadingCompanies = ref(false);
    const getCompanies = async (rut) => {
      loadingCompanies.value = true;
      try {
        const response = await store.dispatch(
          FETCH_COMPANIES_FOR_DEPENDENTS_INCORPORATION_FORM,
          rutHelper.normalizeRut(rut)
        );
        companies.value = response.map((c) => ({
          label: c.businessName,
          value: String(c.id)
        }));
      } catch (error) {
        notification('error', 'Error', error.response.data.message);
      }
      loadingCompanies.value = false;
    };

    // Obteniendo Aseguradoras
    const getInsuranceCompanies = async (id_company) => {
      inputsLockState[1].disabled = true;
      inputsLockState[1].loading = true;
      try {
        await store.dispatch(FETCH_INSURANCE_COMPANIES, {
          id_company
        });
      } catch (error) {
        notification('error', 'Error', error.response.data.message);
      }
      inputsLockState[1].loading = false;
      inputStatesHeriarchy(1);
    };

    // Obteniendo documentos por compa;ia aseguradora
    const getInsuraceDocuments = async (id_insurance) => {
      inputsLockState[2].disabled = true;
      inputsLockState[2].loading = true;
      try {
        await store.dispatch(FETCH_INSURANCE_COMPANIES_DOCUMENTS, id_insurance);
      } catch (error) {
        notification('error', 'Error', error.response.data.message);
      }
      inputsLockState[2].loading = false;
      inputStatesHeriarchy(2);
    };

    const companyPolicies = ref([]);
    const getPolicies = async (rut, id_company, id_insurance) => {
      try {
        const response = await store.dispatch(
          FETCH_POLICIES_FOR_DEPENDENTS_INCORPORATION_FORM,
          {
            rut: rutHelper.normalizeRut(rut),
            companyId: Number(id_company),
            insuranceCompanyId: Number(id_insurance)
          }
        );
        companyPolicies.value = response.map((p) => ({
          label: `${p.numberPolicy}`,
          value: String(p.id),
          groupOptions: p.groupCompanies.map((g) => {
            return {
              label: g.name,
              value: g.id.toString()
            };
          })
        }));
      } catch (error) {
        notification('error', 'Error', error.response.data.message);
      }
    };

    const getEmployeeDataByRut = async (rut) => {
      /*
      Este tiene más logica, al momento de obtener los datos de la persona por rut
      voy a rellenar inmediatamente los selectores que tienen la data
      */
      store
        .dispatch(FETCH_EMPLOYEE_DATA_BY_RUT, rutHelper.normalizeRut(rut))
        .then(() => {
          const { id, fullname } = store.getters[GET_EMPLOYEE_DATA];
          employeeId.value = id;
          employeeName.value = fullname;
        })
        .finally(() => {
          formRef.value.validate(['rut']);
        });
    };

    watch(
      () => formData.company,
      async (newId) => {
        formData.insurance = ''; // Selector de Aseguradora

        // Obtengo la lista de aseguradoras
        if (newId != '') {
          await getInsuranceCompanies(newId);
        }
      }
    );

    // Si selecciono una compañia de seguros
    watch(
      () => formData.insurance,
      async (newId) => {
        formData.policies = []; // Selector de polizas la dejo en vacio

        if (newId != '') {
          await getInsuraceDocuments(newId);
        }
      }
    );

    // Para la seleccion de polizas, necesito que el usuario, tenga rellenado en el formulario
    // # Rut
    // # Compañia
    // # Aseguradora

    const debounce = (cb, delay = 1000) => {
      let timeout;

      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          cb(...args);
        }, delay);
      };
    };

    const updateDebouceRut = debounce(async (text) => {
      await getEmployeeDataByRut(text);
      await getCompanies(text);
    }, 500);

    const validRut = computed(() => rutHelper.validateRut(formData.rut));

    watch(
      () => formData.rut,
      (newRut) => {
        if (newRut != '' && Rut.validateRut(newRut)) {
          updateDebouceRut(newRut);
        }
      }
    );

    watch(
      () => [formData.rut, formData.company, formData.insurance],
      async ([newRut, newCompany, newInsurance]) => {
        if (Rut.validateRut(newRut) && newCompany != '' && newInsurance != '') {
          await getPolicies(newRut, newCompany, newInsurance);
        }
      }
    );

    // Lista de puntos a tener en cuenta cuando comencemos a llamar al endpoint de coberturas
    // [ ] Que exista un empleado encontrado en el sistema (employeeId.value)
    // [ ] Que el rut sea valido tambien
    // [ ] que el id de company exista
    // [ ] que el id de aseguradora exista
    /*
    Entonces al momento de cualquier de estas opciones exista o cambie, se tiene que llamar al endpoint para obtener las coberturas
    pero tiene que hacerse 2 veces, tanto coberturas vigentes como no vigentes y guardar la data por separado
    por que asi voy a poder poner la cantidad de vigentes en el boton
    */

    const currentCoverages = ref([]);
    const notCurrentCoverages = ref([]);

    const getCoveragesRefactored = (data) => {
      if (data.length > 0) {
        let indexCounter = 0;
        return data.flatMap((policy, index) =>
          policy.coverages.map((coverage) => {
            const new_coverage = {
              id: `# ${index + 1}`,
              key: indexCounter,
              policy_number: policy.numberPolicy,
              coverage: coverage.name
            };
            indexCounter += 1;
            return new_coverage;
          })
        );
      }
      return data;
    };

    watch(
      () => [
        employeeId.value,
        formData.rut,
        formData.company,
        formData.insurance
      ],
      async ([newEmployeeId, newRut, newCompany, newInsurance]) => {
        if (
          newEmployeeId != '' &&
          newEmployeeId != undefined &&
          Rut.validateRut(newRut) &&
          newCompany != '' &&
          newInsurance != ''
        ) {
          loadingPolicyCoverages.value = true;
          const current = await getCurrentEmployeeCoverages({
            id: newEmployeeId,
            companyId: newCompany,
            insuranceCompanyId: newInsurance,
            policyStatus: 'Vigente',
            coverageStatus: 'ACTIVE'
          });
          currentCoverages.value = getCoveragesRefactored(current);

          const not_current = await getCurrentEmployeeCoverages({
            id: newEmployeeId,
            companyId: newCompany,
            insuranceCompanyId: newInsurance,
            policyStatus: 'No Vigente',
            coverageStatus: 'INACTIVE'
          });

          notCurrentCoverages.value = getCoveragesRefactored(not_current);
          loadingPolicyCoverages.value = false;
        } else {
          store.dispatch(ACTION_CURRENT_EMPLOYEE_COVERAGE, []);
          currentCoverages.value = [];
          notCurrentCoverages.value = [];
        }
      }
    );

    const loadingPolicyCoverages = ref(false);
    const getCurrentEmployeeCoverages = async (payload) => {
      try {
        const resp = await store.dispatch(
          FETCH_CURRENT_EMPLOYEE_COVERAGE,
          payload
        );
        return resp.data;
      } catch (error) {
        notification('error', 'Error', error.response.data.message);
        loadingPolicyCoverages.value = false;
      }
    };

    const policyColumns = [
      {
        title: 'Id Poliza',
        dataIndex: 'id'
      },
      {
        title: 'N° Póliza',
        dataIndex: 'policy_number'
      },
      {
        title: 'Cobertura',
        dataIndex: 'coverage'
      }
    ];

    const insuranceCompanies = computed(() => {
      return store.getters[GET_INSURANCE_COMPANIES].map((obj) => {
        return {
          label: obj.businessName,
          value: obj.id.toString(),
          formType: obj.insuranceCompanyForm
            ? obj.insuranceCompanyForm.type
            : 'PDF_FORM',
          formFields: obj.formFields || []
        };
      });
    });

    // Fields configurable per insurance company for dependents. The backend
    // now returns a single flat array per insurer (no more per-process
    // split); Colaborador mode never requires them, Compañía mode uses the
    // array as-is.
    const selectedFormFields = computed(() => {
      const selected = insuranceCompanies.value.find(
        (i) => i.value === formData.insurance
      );
      if (!selected) return [];
      return formData.typeform == 1 ? [] : selected.formFields;
    });

    // Limpia el sexo de las cargas si ya no está en la lista resuelta (cambió
    // la aseguradora o el modo Colaborador/Compañía)
    watch(selectedFormFields, (newFields) => {
      if (!newFields.some((f) => f.field === 'gender')) {
        formData.dependents.forEach((d) => {
          d.gender = null;
        });
      }
    });

    const insuranceDocuments = computed(() => {
      return store.getters[GET_INSURANCE_COMPANIES_DOCUMENTS].map((x) => {
        return {
          label: x.name,
          value: x.id
        };
      });
    });

    // * Modal de resumen
    const resumeModal = reactive({
      visibility: false,
      buttonLoading: false,
      data: {
        date: '',
        insurer: '',
        company: '',
        policies: '',
        files: [],
        documents: [],
        rut: '',
        name: '',
        last: '',
        email: '',
        dependents: []
      }
    });

    const openResumeModal = (data) => {
      // Obtengo la data y la trasnformo para enviarla al backend

      resumeModal.data.date = parseDate(data.validityDate).substring(0, 10);
      resumeModal.data.insurer = insuranceCompanies.value.find(
        (x) => x.value == data.insurance
      ).label;
      resumeModal.data.company = companies.value.find(
        (x) => x.value == data.company
      ).label;
      resumeModal.data.policies = formData.policies
        .map((p) => {
          const groups = p.groupOptions
            .filter((g) => p.groupCompanies.includes(g.value))
            .map((g) => g.label)
            .join(', ');
          return `${p.numberPolicy} (${groups})`;
        })
        .join(', ');

      if (formData.typeform == 1) {
        if (data.documents !== undefined) {
          resumeModal.data.documents = insuranceDocuments.value
            .map((x) => {
              return data.documents.includes(x.value) ? x.label : '';
            })
            .filter((el) => el !== '');
        } else {
          resumeModal.data.documents = [];
        }
      } else {
        resumeModal.data.files =
          data.fileList == undefined || data.fileList == []
            ? ''
            : data.fileList.map((x) => {
                return x.name;
              });
        const dependents = {};
        Object.keys(data).forEach((key) => {
          if (key.includes('dependents')) {
            const index = key.split(',')[1];
            const attr = key.split(',')[2];
            if (!dependents[index]) {
              dependents[index] = {};
            }
            dependents[index][attr] = data[key];
          }
        });
        resumeModal.data.dependents = Object.values(dependents);
      }

      resumeModal.data.rut = rutHelper.formatRut(data.rut);

      // Abro el modal
      resumeModal.visibility = true;
    };

    const closeResumeModal = () => {
      resumeModal.visibility = false;
    };

    // * Modal Coberturas y polizas
    const policyCoveragesModalRef = ref();
    const openPolicyCoverage = () => {
      policyCoveragesModalRef.value.openModal();
    };

    // * Modal success
    const show_sucess = ref(false);

    const showError = ref(false);

    const verTicket = () => {
      router.push({
        name: 'AltaCargasDetalle',
        params: { id: ticketId.value }
      });
    };
    const handleOk = () => {
      show_sucess.value = false;
      showError.value = false;
    };

    const relationOptions = [
      {
        label: 'Cónyuge',
        value: 'SPOUSE'
      },
      {
        label: 'Conviviente',
        value: 'COHABITANT'
      },
      {
        label: 'Hijo(a)',
        value: 'CHILD'
      },
      {
        label: 'Padre/Madre',
        value: 'PARENT'
      },
      {
        label: 'Nieto(a)',
        value: 'GRANDCHILD'
      },
      {
        label: 'Hermano(a)',
        value: 'SIBLING'
      }
    ];

    return {
      // Variables
      handleOk,
      showError,
      verTicket,
      formRef,
      showSucess,
      formData,
      formRules,
      options1,
      uploading,
      fileList,
      companies,
      inputsLockState,
      insuranceCompanies,
      companyPolicies,
      resumeModal,
      formatDate,
      show_sucess,
      ticketId,
      insuranceDocuments,
      routes,
      policyStatus,
      policyColumns,
      loadingPolicyCoverages,
      policyCoveragesModalRef,
      employeeId,
      employeeName,
      // Functions
      onSubmitForm,
      showPendingPolicyModal,
      pendingPolicyConflicts,
      handleRemove,
      beforeUpload,
      handleUpload,
      parseDate,
      createAlta,
      closeResumeModal,
      formatRuts,
      handleRemoveOptional,
      beforeUploadOptional,
      getCurrentEmployeeCoverages,
      openPolicyCoverage,
      validRut,
      currentCoverages,
      notCurrentCoverages,
      handleAddDependent,
      handleDeleteDependent,
      rutValidator,
      rutHelper,
      loadingCompanies,
      relationOptions,
      genderOptions,
      selectedFormFields,
      handleAddPolicy,
      handleDeletePolicy,
      handleDeleteAllDependents
    };
  }
};
</script>
